import React from "react";
import { AppContext } from "contexts/app";
import stylesLess from "./index.module.less";
import { get_advertising } from "api/uaapi/user";
import sessionStorage from "utils/sessionStorage";
import { message } from "antd";
import { useIntl } from "react-intl";

export default function Layout({ countryInfo, children }) {
  const intl = useIntl();
  const [appState, appDispatch] = React.useContext(AppContext);

  const [state_ad, setState_ad] = React.useState(null);

  React.useEffect(() => {
    // if (window === undefined) return;
    // console.log("addddd", { lang: appState.lang, countryInfo });
    const countryObj =
      countryInfo === undefined
        ? sessionStorage.get("countryInfo")
        : countryInfo;
    if (!countryObj) return;

    const id = countryObj.id + "";
    if (id) {
      get_advertising(id).then((data) => {
        if (data && data.isDisplay) setState_ad(data);
        else setState_ad(null);
      });
    }
  }, [appState.lang, countryInfo]);

  return (
    <div className={`${stylesLess.main} ${appState.isDark ? "dark" : "light"}`}>
      <div className={"iWin"}>{children}</div>
    </div>
  );
}
